module.exports = __webpack_public_path__ + "static/media/poolHeating.b91af084.png";